import React from 'react';
import { Redirect } from 'react-router-dom';
import { isInclusive, range } from '../../helpers/util';
import withOnboarding from './withOnboarding';

class OnboardingStep extends React.Component {
  render() {
    const nextStep = this.props.steps[this.props.step + 1] || {};
    const thisStep = this.props.steps[this.props.step] || {};
    const lastStep = this.props.steps[this.props.step - 1] || {};

    // if this step is complete, redirect to next step
    if (this.props.isComplete) {
      return (
        <Redirect
          to={{
            pathname: nextStep.path || '/',
            state: { from: thisStep.path }
          }}
        />
      );
    }

    const expected = range(this.props.step);
    if (this.props.step > 0 && !isInclusive(expected, this.props.progress)) {
      return (
        <Redirect
          to={{
            pathname: lastStep.path || '/',
            state: { from: thisStep.path }
          }}
        />
      );
    }

    const { Component, ...rest } = this.props;
    return <Component {...rest} />;
  }

  componentDidUpdate() {
    if (this.props.isComplete) this.props.actions.reset();
  }

  componentDidMount() {
    if (this.props.step) this.props.actions.setStep(this.props.step);
  }
}
export default withOnboarding(OnboardingStep);



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingStep.js